<template>
  <div class="otheralbum">
    <div class="comp-title">
      <div class="left">
        <h1 class="text-uppercase color-text-bold">
          <img src="../../../../static/img/comp-title.png"/>
          Chủ đề khác
        </h1>
      </div>
    </div>
    <div style="clear:both;"></div>

    <div>
      <div v-for="item in dataList" class="item text-left">
        <a :href="prefixUrl + item.albumCode">
          <img :src="item.avatar != '' ? item.avatar : defaultThumbnail"/>
          <h2 class="color-text song">{{ item.albumName }}</h2>
          <!--<p class="singer color-text">{{ item.singer }}</p>-->
        </a>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: "OtherAlbum",
    data () {
      return {
        prefixUrl: this.settings.prefixAlbum,
        defaultThumbnail: this.settings.defaultThumbnailAlbum,
        dataList: [
          {
            "code": "alubum1",
            "thumbnail": "https://i.ytimg.com/vi/wGo1AgERSvo/maxresdefault.jpg",
            "title": "Nếu có lỡ xa lìa nhau",
            "singer": "Tuấn hưng"
          },
          {
            "code": "alubum1",
            "thumbnail": "https://i.ytimg.com/vi/wGo1AgERSvo/maxresdefault.jpg",
            "title": "Nếu có lỡ xa lìa nhau",
            "singer": "Tuấn hưng"
          }
        ]
      }
    },
    methods: {
      getListAlbum(){
        axios.post(api.otherAlbum, {pageSize: 3, code: this.$route.params.code})
          .then(response => {
            this.dataList = response.data.result;
          })
          .catch(e => {
            console.log("Other album---");
            console.log(e);
          })
      }
    },
    watch: {
      "$route.params.code": {
        handler: "getListAlbum",
        immediate: true
      }
    }
  }
</script>

<style scoped>
    .item img{
      width: 100%;
      height: 200px;
    }
</style>



// WEBPACK FOOTER //
// src/components/albumplay/web/OtherAlbum.vue